import {connect} from 'react-redux';

import {ViewerPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {createSelector, makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../store/appState';
import {makeGetCanLinkConversation} from '../../../store/data/conversations/linkedConversationsSelectors';
import {getConversations} from '../../../store/data/dataSelectors';
import {jumpToActivityAsyncAction} from '../../../store/panels/viewer/viewerPanelActions';
import {AnnotationsHighlightViewer} from './annotationsHighlightViewer';

/*
 * Props.
 */

interface AnnotationsHighlightViewerContainerProps {
  conversationId: number;
  isAnnotatingComment?: boolean;
}

/*
 * Selectors.
 */

function getConversationId(_state: AppState, props: AnnotationsHighlightViewerContainerProps) {
  return props.conversationId;
}

function getIsAnnotatingComment(_state: AppState, props: AnnotationsHighlightViewerContainerProps) {
  return Boolean(props.isAnnotatingComment);
}

function makeGetConversation() {
  return createSelector(
    [getConversations, getConversationId],
    (conversations, conversationId) => conversations[conversationId],
  );
}

function makeGetNamespace(getConversation: ReturnType<typeof makeGetConversation>) {
  return createSelector([getConversation], (conversation) => conversation?.namespace);
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<AnnotationsHighlightViewerContainerProps>()(() => {
  const getConversation = makeGetConversation();

  return {
    isAnnotatingComment: getIsAnnotatingComment,
    conversationId: getConversationId,
    namespace: makeGetNamespace(getConversation),
    canLinkConversation: makeGetCanLinkConversation(getConversation),
  };
});

const dispatchProps = {
  onJumpToActivity: (value: {panelId: ViewerPanelId; sourceActivityId: number}) =>
    jumpToActivityAsyncAction(value.panelId, {id: value.sourceActivityId}),
};

export const AnnotationsHighlightViewerContainer = connect(
  mapStateToProps,
  dispatchProps,
)(AnnotationsHighlightViewer);
